"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _formatNumber = _interopRequireDefault(require("../char/formatNumber"));

var _constants = require("./constants");

var unitsEquivalence = {
  km: {
    coeficient: 0.621371,
    imperialUnit: 'mi'
  },
  kilometer: {
    coeficient: 0.621371,
    imperialUnit: 'mile'
  },
  kilometers: {
    coeficient: 0.621371,
    imperialUnit: 'miles'
  },
  kilometre: {
    coeficient: 0.621371,
    imperialUnit: 'mile'
  },
  kilometres: {
    coeficient: 0.621371,
    imperialUnit: 'miles'
  },
  kilomètre: {
    coeficient: 0.621371,
    imperialUnit: 'mile'
  },
  kilomètres: {
    coeficient: 0.621371,
    imperialUnit: 'miles'
  },
  m: {
    coeficient: 3.28084,
    imperialUnit: 'ft'
  },
  mètres: {
    coeficient: 3.28084,
    imperialUnit: 'feets'
  },
  meters: {
    coeficient: 3.28084,
    imperialUnit: 'feets'
  }
};
var distanceRegex = /([0-9]+\s?)+[.,]?([0-9]?)+/gi;
var distanceUnitRegex = /(k?m)|(kilom(è|e)tre(s)?|kilometer(s)?)/gi;
var otherUnitRegex = /(k?m)|(kilom(è|e)tre(s)?|kilometer(s)?)|(pas|step(s)?|pas(s)o(s)|passi(s)|stappen|pașilor)/gi;
var objectiveRegex = /([0-9]+\s?)+[.,]?([0-9]?)+\s?((k?m)|(kilom(è||e)tre(s)?|kilometer(s)?|mètre(s)?|meter(s)?)|(pas|step(s)?|pas(s)o(s)|passi(s)|stappen|pașilor))+([.,*]+)?($|\s|<)/gi;

var convertInImperial = function convertInImperial(distance, locale, measurementSystem) {
  var hasEndingPunctuation = distance.match(/([.,\s*><]+\s?)$/gi);
  var endingPunctuation = hasEndingPunctuation !== null ? hasEndingPunctuation[0] : '';
  var extractedDistance = distance.match(distanceRegex)[0];
  var formatedExtractedDistance = extractedDistance.replace(/,/g, '.').replace(/\s/g, '');
  var matchDistanceUnit = distance.match(distanceUnitRegex);

  if (!matchDistanceUnit || measurementSystem === 'metric') {
    var extractedUnit = distance.match(otherUnitRegex)[0].toLowerCase();
    return "".concat((0, _formatNumber["default"])(parseFloat(formatedExtractedDistance), {
      locale: locale
    }), " ").concat(extractedUnit).concat(endingPunctuation);
  }

  var extractedDistanceUnit = matchDistanceUnit[0].toLowerCase();
  return "".concat((0, _formatNumber["default"])(parseFloat((parseFloat(formatedExtractedDistance) * unitsEquivalence[extractedDistanceUnit].coeficient).toFixed(_constants.decimalNumber)), {
    locale: locale
  }), " ").concat(unitsEquivalence[extractedDistanceUnit].imperialUnit).concat(endingPunctuation);
};

var formatStringWithMeasurementSystem = function formatStringWithMeasurementSystem(_ref) {
  var objective = _ref.objective,
      measurementSystem = _ref.measurementSystem,
      locale = _ref.locale;

  if (typeof objective !== 'string') {
    return '';
  }

  var replaceObjectiveAccent = objective.replace(/&egrave;/g, 'è');
  var matchObjective = replaceObjectiveAccent.match(objectiveRegex);

  if (!matchObjective) {
    return objective;
  }

  return matchObjective.reduce(function (acc, match) {
    return acc.replace(match, convertInImperial(match, locale, measurementSystem));
  }, replaceObjectiveAccent);
};

var _default = formatStringWithMeasurementSystem;
exports["default"] = _default;
//# sourceMappingURL=formatStringWithMeasurementSystem.js.map